import { TableLink } from './table-link';

export interface EntityLinkProps {
  /** Detail route for the entity. */
  to: string;
  /** Numeric / string id shown before the name. */
  id: number | string;
  /** Display name; when absent the cell shows just the id. */
  name?: string | null;
}

/**
 * The one entity-reference cell used by every table that links to an object
 * (service, customer, contract, invoice, org, …). Renders `{id} – {name}` on a
 * SINGLE line, linked and truncated via {@link TableLink}. Never hand-roll a
 * name link with an "ID …" / "Org …" sub-line or a wrapped second row — use this
 * so every id/name reference reads identically across the app.
 */
export function EntityLink({ to, id, name }: EntityLinkProps) {
  const label = name ? `${id} – ${name}` : String(id);
  return (
    <TableLink to={to} title={label} truncate>
      {label}
    </TableLink>
  );
}
